<app-breadcrumb [title]="'Datos Facturación'" [breadcrumb]="'Datos Facturación'"></app-breadcrumb>
<section class="section-b-space blog-detail-page review-page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 d-flex flex-column justify-content-center align-items-center gap-3">
                <h6 class="text-center">Agrega tus datos de facturación aquí haciendo clic en el botón 'Agregar'. Asegúrate de proporcionar información precisa para generar tus facturas correctamente.</h6>
                <div style="float: right; margin-right: 10px;">
                    <button (click)="agregarDatos()" class="btn btn-solid" id="guardarBoton">
                        <span>Agregar</span>
                    </button>&nbsp;
                </div>
            </div>
        </div>
        <div class="col-sm-12" style="margin-top: 10px">
            <div class="card-body">
                <div class="comment-section"  *ngFor="let data of listaDatosFacturacion; let i = index; let impar = odd;let par = even;" [ngClass]="{azul:par,gris:impar}" style="padding: 0px 0px 0px 20px;">
                    <li>
                        <div class="media">
                            <div class="icon">
                                <i class="fa fa-file-text" aria-hidden="true"></i>
                            </div>
                            <div class="col-sm-12 row nb-2" style="margin-left: -48px; padding: 0px 0px 0px 45px">
                                <h6>Referencia: DATOS # {{i+1}}</h6>
                                <div class="col-md-6 row">
                                    <div class="row" style="display: inline-flex;">
                                        <h4 style="color: #176ec0;">Clave del Registro Federal de Contribuyentes (RFC): <h5> {{ data.rfc | uppercase }} </h5> <h5 *ngIf="data.rfc == null || data.rfc == '' ">Sin información</h5> </h4>
                                    </div>
                                </div>
                                <div class="col-md-6 row">
                                    <div class="row" style="display: inline-flex;">
                                        <h4 style="color: #176ec0;">Nombre, denominación o razón social: <h5> {{data.nombre}} </h5> <h5 *ngIf="data.rfc == null || data.rfc == '' ">Sin información</h5> </h4>
                                    </div>
                                </div>
                                <div class="col-md-4 row">
                                    <div class="row" style="display: inline-flex;">
                                        <h4 style="color: #176ec0;">Código Postal: <h5> {{data.cp}} </h5> <h5 *ngIf="data.rfc == null || data.rfc == '' ">Sin información</h5> </h4>
                                    </div>
                                </div>
                                <div class="col-md-4 row">
                                    <div class="row" style="display: inline-flex;">
                                        <h4 style="color: #176ec0;">Régimen Fiscal: <h5> {{data.regimenFiscal}} </h5> <h5 *ngIf="data.rfc == null || data.rfc == '' ">Sin información</h5> </h4>
                                    </div>
                                </div>
                                <div class="col-md-4 row">
                                    <div class="row" style="display: inline-flex;">
                                        <h4 style="color: #176ec0;">Uso CFDI: <h5> {{data.usoCfdi}} </h5> <h5 *ngIf="data.rfc == null || data.rfc == '' ">Sin información</h5> </h4>
                                    </div>
                                </div>
                                <div class="row">
                                    <!-- <div class="col-md-12 row">
                                        <div class="col-md-12">
                                            <button (click)="editarData(data.id)" class="btn btn-solid" id="guardarBoton">
                                                <span>Editar datos de facturación</span>
                                            </button>&nbsp;
                                            <button (click)="eliminarData(data.id)" class="btn btn-solid" id="guardarBoton">
                                                <span>Eliminar</span>
                                            </button>&nbsp;
                                        </div>                                            
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </li>
                </div>
            </div>
        </div>
    </div>
</section>